import React, { useState } from 'react'
import { useFormContext } from 'react-hook-form'
import TextInput from '../../../../shared/Inputs/TextInput/TextInput'
import DatePicker from '../../../../shared/Inputs/DatePicker/DatePicker'
import { UPLOADS_ENDPOINT } from '../../../../server-parameters'
import { yearsAgo, passportInputHandler } from '../../../../utils/helpers'
import {
  validateName,
  validateDate,
  passportDigits,
  passportText,
  smartValidateString,
} from '../../../../validate/validators'
import { Country, Lang } from '../../../../types/common-types'
import { State } from '../../../../state-actions-reducers'
import FileInput from '../../../../shared/Inputs/FileInput/FileInput'
import { PassportType } from '../../../../enums/passportTypeEnum'
import IdentityExist from '../../../../components/IdentityExist/IdentityExist'

export default function RussianForm({
  lang,
  accountForm,
}: { lang: Lang; accountForm: any }) {
  const { watch, setValue, getValues, formState: { errors } } = useFormContext<State>()
  const state = watch()
  const [focus, setFocus] = useState('')
  return (
    <>
      <div className="col-2 col-xs-12">
        {/* PASSPORT SERIES / NUMBER */}
        <TextInput
          disabled={!state.agreed}
          lang={lang}
          content={accountForm.passportNumber}
          onChange={passportNumber => {
            setValue('passportNumber', passportNumber, { shouldDirty: true })
          }}
          value={state.passportNumber}
          required
          valid={
            passportDigits(state.passportNumber) &&
            !errors.passportNumber
          }
          onBlur={() => setFocus('')}
          mask={'9999 999999'}
        />
      </div>
      <IdentityExist
            accountForm={accountForm}
            lang={lang}
            show={!state.isIdentityOk}
          />
      <div className="col-8 col-xs-12">
        {/* PASSPORT ISSUED BY */}
        <TextInput
          disabled={!state.agreed}
          lang={lang}
          content={accountForm.issuedBy}
          onChange={passportIssuedBy =>
            setValue('passportIssuedBy', passportIssuedBy.toLocaleUpperCase(), { shouldDirty: true })
          }
          value={state.passportIssuedBy}
          required
          valid={
            state.passportIssuedBy.length > 0
              ? smartValidateString(state.passportIssuedBy) &&
                !errors.passportIssuedBy
              : !errors.passportIssuedBy
          }
          onBlur={() => setFocus('')}
        />
      </div>
      <div className="col-2 col-xs-12">
        {/* PASSPORT ISSUE DATE */}
        <DatePicker
          disabled={!state.agreed}
          lang={lang}
          accountForm={accountForm}
          accountFormKey="passportIAt"
          onChange={data => setValue('passportIAt', data, { shouldDirty: true })}
          value={state.passportIAt}
          required
          valid={!errors.passportIAt}
          onBlur={() => setFocus('')}
          curr={
            state.birthDate
              ? new Date(
                  new Date(state.birthDate).setFullYear(
                    new Date(state.birthDate).getFullYear() + 14
                  )
                )
              : new Date()
          }
          min={
            state.birthDate
              ? new Date(
                  new Date(state.birthDate).setFullYear(
                    new Date(state.birthDate).getFullYear() + 14
                  )
                )
              : new Date(new Date().setFullYear(new Date().getFullYear() - 67))
          }
          max={new Date()}
        />
      </div>
      <div className="col-2 col-xs-12">
        {/* PASSPORT AUTHORITY CODE */}
        <TextInput
          disabled={!state.agreed}
          lang={lang}
          content={accountForm.passportAuthorityCode}
          onChange={passportAuthorityCode => {
            const authorityCode = passportInputHandler({
              newValue: passportAuthorityCode,
              oldValue: state.passportAuthorityCode,
              isRussianPassport:
                Number(state.passportType) === PassportType.Passport,
              kind: 'authority',
            })
            setValue('passportAuthorityCode', authorityCode, { shouldDirty: true })
          }}
          value={state.passportAuthorityCode}
          required={true}
          valid={
            passportDigits(state.passportAuthorityCode) &&
            !errors.passportAuthorityCode
          }
          onBlur={() => setFocus('')}
          focus={focus === 'passportAuthorityCode' || undefined}
        />
      </div>
      <div className="col-4 col-xs-12">
        <FileInput
          disabled={!state.agreed}
          lang={lang}
          url={UPLOADS_ENDPOINT}
          autorization={state.formId}
          target={state.passportImages}
          content={accountForm.mainImageFile}
          
          onChange={data => {
            setValue('mainImageFile', data, { shouldDirty: true })
          }}
          valid={!errors.mainImageFile}
          documentType="Passport1"
          value={state.mainImageFile[state.mainImageFile.length - 1]}
          imageErrors={state.imageError}
        />
      </div>
      <div className="col-4 col-xs-12">
        <FileInput
          disabled={!state.agreed}
          lang={lang}
          url={UPLOADS_ENDPOINT}
          autorization={state.formId}
          target={state.passportImages}
          content={accountForm.addressImageFile}
          
          onChange={data => {
            setValue('addressImageFile', data, { shouldDirty: true })
          }}
          value={state.addressImageFile[state.addressImageFile.length - 1]}
          valid={!errors.addressImageFile}
          documentType="Passport2"
          imageErrors={state.imageError}
        />
      </div>
    </>
  )
}
